<template>
  <div class="Backlog">
    <InfoBox
      :title="title"
    >
      <Message
        v-for="message in messages"
        :key="message.title"
        :message="message"
      />
    </InfoBox>
  </div>
</template>

<script>
import Message from '@/components/information/sub/Msgtwo.vue';
import InfoBox from '@/components/information/sub/InfoBox.vue';
import { getHotBacklogs } from '@/api/backlog';

export default {
  components: { Message, InfoBox },
  data() {
    return {
      title: '待办事项',
      messages: null,
    };
  },
  created() {
    getHotBacklogs().then((data) => {
      this.messages = data;
    });
  },
};
</script>
